import type { TvShow } from '@/types/tv';

export const shows: TvShow[] = [
  {
    id: 'chang-ye-xing-ge',
    title: '长夜行歌',
    originalTitle: 'Song of the Long Night',
    score: 9.3,
    year: 2024,
    region: '国产剧',
    categories: ['guochan', 'guzhuang', 'xuanyi'],
    tags: ['古装', '悬疑', '权谋'],
    episodes: 40,
    duration: '45分钟',
    firstAir: '2024-03-18',
    director: '陆亦寒',
    writers: '苏清和 / 林晚舟',
    cast: [
      { name: '沈知white', role: '裴照雪', bio: '以细腻克制的表演著称，多次获年度最佳男主角提名。' },
      { name: '温子瑜', role: '苏听澜', bio: '擅长塑造复杂女性角色，代表作口碑与人气兼备。' },
      { name: '程慕言', role: '萧无咎', bio: '戏路宽阔，正邪两面皆能驾驭的实力派演员。' },
      { name: '顾清晏', role: '太后', bio: '资深表演艺术家，举手投足皆是戏。' },
    ],
    intro: '一桩连环命案牵动王朝根基，年轻的查案者踏入了权谋的深夜里。',
    synopsis: [
      '王朝末年，京城接连发生数起扑朔迷离的命案，死者皆为朝中重臣。大理寺年轻推官裴照雪受命彻查，却发现每一条线索都指向深不可测的权力漩涡。',
      '在追查真相的过程中，他与神秘的女医苏听澜结盟，二人逐渐发现案件背后隐藏着一份足以动摇王朝的旧档。真相越近，危险越近，长夜之中，唯有歌声不曾停歇。',
    ],
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20TV%20series%20poster%20art%20of%20an%20ancient%20Chinese%20court%20scholar%20in%20flowing%20robes%20standing%20in%20a%20moonlit%20courtyard%2C%20dramatic%20moody%20lighting%2C%20deep%20navy%20blue%20and%20warm%20amber%20orange%20color%20grade%2C%20elegant%20minimal%20composition%2C%20high%20detail%2C%20professional%20film%20key%20art%2C%20no%20text&width=600&height=900&seq=tvposter-01&orientation=portrait',
    heroImage: 'https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20an%20ancient%20Chinese%20palace%20corridor%20at%20night%20with%20lanterns%20and%20mist%2C%20lone%20figure%20walking%2C%20dramatic%20moody%20lighting%2C%20deep%20navy%20blue%20and%20warm%20amber%20orange%20color%20grade%2C%20epic%20film%20still%2C%20high%20detail%2C%20no%20text&width=1600&height=900&seq=tvhero-01&orientation=landscape',
    updatedAt: '2026-08-22',
    featured: true,
    status: '已完结',
  },
  {
    id: 'mi-wu-hui-lang',
    title: '迷雾回廊',
    originalTitle: 'Corridor of Mist',
    score: 9.2,
    year: 2024,
    region: '国产剧',
    categories: ['guochan', 'xuanyi', 'fanzui'],
    tags: ['悬疑', '犯罪', '刑侦'],
    episodes: 24,
    duration: '42分钟',
    firstAir: '2024-06-11',
    director: '韩牧之',
    writers: '周砚',
    cast: [
      { name: '江执野', role: '刑侦队长 顾行舟', bio: '硬汉形象深入人心，擅长高强度情绪戏。' },
      { name: '林清陌', role: '法医 沈知夏', bio: '冷感气质与细腻情感并存的青年演员。' },
      { name: '赵屿', role: '嫌疑人 陈默', bio: '以反派角色多次出圈，表演极具压迫感。' },
    ],
    intro: '一名失踪十年的女孩重新出现，却牵出了一座城市尘封的秘密。',
    synopsis: [
      '一宗十年前的失踪案随着女孩的意外归来重新启动，刑侦队长顾行舟与法医沈知夏被迫重新审视当年的每一个细节。',
      '随着调查深入，他们发现案件中每个人的证词都经过了精心的编排，而真相被藏在一条看不见的回廊深处。',
    ],
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20TV%20series%20poster%20art%20of%20a%20detective%20silhouette%20in%20a%20foggy%20urban%20alley%20at%20night%2C%20neon%20reflections%20on%20wet%20pavement%2C%20deep%20navy%20blue%20and%20warm%20amber%20orange%20color%20grade%2C%20elegant%20minimal%20composition%2C%20high%20detail%2C%20professional%20film%20key%20art%2C%20no%20text&width=600&height=900&seq=tvposter-02&orientation=portrait',
    heroImage: 'https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20a%20rainy%20city%20street%20at%20night%20with%20fog%20and%20glowing%20streetlights%2C%20mysterious%20atmosphere%2C%20deep%20navy%20blue%20and%20warm%20amber%20orange%20color%20grade%2C%20epic%20film%20still%2C%20high%20detail%2C%20no%20text&width=1600&height=900&seq=tvhero-02&orientation=landscape',
    updatedAt: '2026-09-30',
    featured: true,
    status: '已完结',
  },
  {
    id: 'chen-mo-de-zheng-ci',
    title: '沉默的证词',
    originalTitle: 'The Silent Testimony',
    score: 9.3,
    year: 2025,
    region: '国产剧',
    categories: ['guochan', 'fanzui', 'xuanyi'],
    tags: ['犯罪', '悬疑', '律政'],
    episodes: 32,
    duration: '44分钟',
    firstAir: '2025-01-09',
    director: '秦望川',
    writers: '顾南舟 / 何夕',
    cast: [
      { name: '许听白', role: '辩护律师 江砚', bio: '气质沉稳，擅长诠释理性与情感拉扯的角色。' },
      { name: '洛沉舟', role: '检察官 温言', bio: '台词功底深厚，法庭戏极具张力。' },
      { name: '阮清（demo）', role: '关键证人 阿棠', bio: '新生代演员，表演真挚有灵气。' },
    ],
    intro: '一桩铁证如山的旧案，因为一份沉默的证词被彻底推翻。',
    synopsis: [
      '一桩看似证据确凿的凶案在十年后重启，辩护律师江砚接下这个几乎不可能翻案的委托。',
      '在追查中，他发现所有证据都被人为地整理得过于完美，而真正的证词，恰恰藏在所有人的沉默里。',
    ],
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20TV%20series%20poster%20art%20of%20a%20lawyer%20standing%20in%20an%20empty%20courtroom%20with%20shafts%20of%20light%2C%20solemn%20mood%2C%20deep%20navy%20blue%20and%20warm%20amber%20orange%20color%20grade%2C%20elegant%20minimal%20composition%2C%20high%20detail%2C%20professional%20film%20key%20art%2C%20no%20text&width=600&height=900&seq=tvposter-03&orientation=portrait',
    heroImage: 'https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20an%20empty%20marble%20courtroom%20with%20tall%20windows%20and%20dramatic%20light%2C%20solemn%20atmosphere%2C%20deep%20navy%20blue%20and%20warm%20amber%20orange%20color%20grade%2C%20epic%20film%20still%2C%20high%20detail%2C%20no%20text&width=1600&height=900&seq=tvhero-03&orientation=landscape',
    updatedAt: '2026-09-12',
    featured: true,
    status: '已完结',
  },
  {
    id: 'xing-ji-piao-liu-zhe',
    title: '星际漂流者',
    originalTitle: 'Drifters of the Stars',
    score: 9.2,
    year: 2023,
    region: '欧美剧',
    categories: ['oumei', 'kehuan', 'xuanyi'],
    tags: ['科幻', '太空', '悬疑'],
    episodes: 18,
    duration: '52分钟',
    firstAir: '2023-11-02',
    director: 'Elias Moreau',
    writers: 'R. Halden / J. Voss',
    cast: [
      { name: 'Marcus Vale', role: '船长 凯恩', bio: '以沉稳内敛的科幻题材角色闻名。' },
      { name: 'Ingrid Solberg', role: '工程师 莉娜', bio: '表演富有层次，擅长诠释坚韧女性。' },
      { name: 'Theo Ramírez', role: '导航员 迪亚兹', bio: '戏路宽广的舞台剧出身演员。' },
    ],
    intro: '一艘失联的星际飞船返航时，船员发现返回的只有他们自己。',
    synopsis: [
      '一艘执行深空补给任务的飞船在失联数年后意外返航，船上全员生还，却没有人记得这些年发生过什么。',
      '随着调查推进，船员们在飞船的日志里发现了不属于任何人的记录，而真相指向一个远超人类理解的答案。',
    ],
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20science%20fiction%20TV%20series%20poster%20art%20of%20a%20lone%20astronaut%20floating%20before%20a%20vast%20ringed%20planet%2C%20vast%20cosmic%20scale%2C%20deep%20navy%20blue%20and%20warm%20amber%20orange%20color%20grade%2C%20elegant%20minimal%20composition%2C%20high%20detail%2C%20professional%20film%20key%20art%2C%20no%20text&width=600&height=900&seq=tvposter-04&orientation=portrait',
    heroImage: 'https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20a%20starship%20drifting%20through%20a%20nebula%20in%20deep%20space%2C%20epic%20scale%2C%20deep%20navy%20blue%20and%20warm%20amber%20orange%20color%20grade%2C%20epic%20film%20still%2C%20high%20detail%2C%20no%20text&width=1600&height=900&seq=tvhero-04&orientation=landscape',
    updatedAt: '2026-07-18',
    featured: true,
    status: '已完结',
  },
  {
    id: 'wu-gang-mi-zong',
    title: '雾港谜踪',
    originalTitle: 'The Fog Harbour Mystery',
    score: 9.4,
    year: 2024,
    region: '欧美剧',
    categories: ['oumei', 'xuanyi', 'fanzui'],
    tags: ['悬疑', '犯罪', '英剧'],
    episodes: 8,
    duration: '58分钟',
    firstAir: '2024-09-27',
    director: 'Catherine Ashworth',
    writers: 'P. Lindsay',
    cast: [
      { name: 'Oliver Grant', role: '警探 哈里斯', bio: '英国实力派演员，擅长冷峻克制的角色。' },
      { name: 'Marlow Reid', role: '记者 艾琳', bio: '气质独特，代表作多次入围国际奖项。' },
      { name: 'Sean Doherty', role: '船长 麦凯', bio: '以细腻的配角演出广受好评。' },
    ],
    intro: '一座常年被浓雾笼罩的港口小镇，每隔七年就会有人消失。',
    synopsis: [
      '一座北方港口小镇长年被浓雾笼罩，历史上每隔七年便有人神秘失踪。当又一名少女消失后，外地调任的警探哈里斯决定揭开这个规律背后的真相。',
      '随着调查深入，他发现整个小镇的居民都在共同守护着一个秘密，而浓雾之下藏着比失踪更可怕的东西。',
    ],
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20TV%20series%20poster%20art%20of%20a%20lighthouse%20on%20a%20foggy%20harbour%20at%20dusk%20with%20a%20lone%20figure%2C%20eerie%20mood%2C%20deep%20navy%20blue%20and%20warm%20amber%20orange%20color%20grade%2C%20elegant%20minimal%20composition%2C%20high%20detail%2C%20professional%20film%20key%20art%2C%20no%20text&width=600&height=900&seq=tvposter-05&orientation=portrait',
    heroImage: 'https://readdy.ai/api/search-image?query=cinematic%20wide%20shot%20of%20a%20foggy%20northern%20harbour%20town%20at%20dusk%20with%20a%20lighthouse%20and%20moored%20boats%2C%20eerie%20atmosphere%2C%20deep%20navy%20blue%20and%20warm%20amber%20orange%20color%20grade%2C%20epic%20film%20still%2C%20high%20detail%2C%20no%20text&width=1600&height=900&seq=tvhero-05&orientation=landscape',
    updatedAt: '2026-10-02',
    featured: true,
    status: '更新中',
  },
  {
    id: 'shan-he-gu-ying',
    title: '山河故影',
    originalTitle: 'Shadows of Rivers and Mountains',
    score: 9.0,
    year: 2022,
    region: '国产剧',
    categories: ['guochan', 'guzhuang'],
    tags: ['古装', '历史', '家国'],
    episodes: 48,
    duration: '46分钟',
    firstAir: '2022-04-15',
    director: '裴云舟',
    writers: '陆沉',
    cast: [
      { name: '齐北望', role: '将军 谢淮', bio: '硬汉气质与细腻情感兼具的实力男演员。' },
      { name: '苏晚棠', role: '公主 昭宁', bio: '古装扮相出众，表演灵动。' },
    ],
    intro: '乱世之中，一位将军与一位公主共同守护山河的最后尊严。',
    synopsis: [
      '山河破碎的年代，将军谢淮受命镇守边关，与远在京城的公主昭宁以书信相系。',
      '当战火逼近，他们必须在儿女情长与家国大义之间做出抉择。',
    ],
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20historical%20TV%20series%20poster%20art%20of%20an%20armoured%20general%20on%20a%20battlefield%20at%20sunset%20with%20banners%2C%20epic%20mood%2C%20deep%20navy%20blue%20and%20warm%20amber%20orange%20color%20grade%2C%20elegant%20minimal%20composition%2C%20high%20detail%2C%20professional%20film%20key%20art%2C%20no%20text&width=600&height=900&seq=tvposter-06&orientation=portrait',
    heroImage: '',
    updatedAt: '2026-06-04',
    featured: false,
    status: '已完结',
  },
  {
    id: 'da-ming-mi-dang',
    title: '大明密档',
    originalTitle: 'The Ming Secret Files',
    score: 8.8,
    year: 2021,
    region: '国产剧',
    categories: ['guochan', 'guzhuang', 'xuanyi'],
    tags: ['古装', '探案', '权谋'],
    episodes: 36,
    duration: '45分钟',
    firstAir: '2021-08-20',
    director: '白景行',
    writers: '沈砚',
    cast: [
      { name: '傅明诚', role: '锦衣卫 陆昭', bio: '动作戏扎实，冷面角色塑造出色。' },
      { name: '温以宁', role: '女官 沈昭', bio: '气质温婉又透着坚韧。' },
    ],
    intro: '锦衣卫密探循着一册残卷，揭开大明王朝隐藏的惊天秘密。',
    synopsis: [
      '锦衣卫陆昭在一次例行巡查中意外获得一册残缺的密档，从此卷入一场横跨朝野的阴谋。',
      '他与女官沈昭联手，在权力的夹缝中一步步逼近真相。',
    ],
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20ancient%20Chinese%20detective%20TV%20poster%20of%20a%20cloaked%20guard%20holding%20a%20scroll%20in%20a%20dim%20archive%20hall%2C%20mysterious%20mood%2C%20deep%20navy%20blue%20and%20warm%20amber%20orange%20color%20grade%2C%20elegant%20minimal%20composition%2C%20high%20detail%2C%20professional%20film%20key%20art%2C%20no%20text&width=600&height=900&seq=tvposter-07&orientation=portrait',
    heroImage: '',
    updatedAt: '2026-05-09',
    featured: false,
    status: '已完结',
  },
  {
    id: 'ling-long-ce',
    title: '玲珑策',
    originalTitle: 'The Jade Scheme',
    score: 8.6,
    year: 2023,
    region: '国产剧',
    categories: ['guochan', 'guzhuang', 'aiqing'],
    tags: ['古装', '爱情', '权谋'],
    episodes: 42,
    duration: '44分钟',
    firstAir: '2023-02-14',
    director: '苏映雪',
    writers: '林晚',
    cast: [
      { name: '秦昭昭', role: '谋士之女 玲珑', bio: '灵动聪慧，古装甜宠剧代表演员。' },
      { name: '萧承玉', role: '世子 萧决', bio: '气质清贵，古装男主角人气颇高。' },
    ],
    intro: '聪慧的谋士之女与清贵世子，在棋局与真心之间步步为营。',
    synopsis: [
      '谋士之女玲珑为查清父亲冤案潜入侯府，却与世子萧决在博弈中渐生情愫。',
      '一场关于权谋与真心的棋局，就此展开。',
    ],
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20romantic%20costume%20drama%20poster%20of%20an%20elegant%20Chinese%20noblewoman%20and%20young%20lord%20beneath%20blossom%20trees%2C%20tender%20mood%2C%20deep%20navy%20blue%20and%20warm%20amber%20orange%20color%20grade%2C%20elegant%20minimal%20composition%2C%20high%20detail%2C%20professional%20film%20key%20art%2C%20no%20text&width=600&height=900&seq=tvposter-08&orientation=portrait',
    heroImage: '',
    updatedAt: '2026-04-21',
    featured: false,
    status: '已完结',
  },
  {
    id: 'chang-an-mi-an',
    title: '长安谜案',
    originalTitle: 'The Chang\'an Enigma',
    score: 9.1,
    year: 2020,
    region: '国产剧',
    categories: ['guochan', 'guzhuang', 'xuanyi'],
    tags: ['古装', '探案', '悬疑'],
    episodes: 38,
    duration: '45分钟',
    firstAir: '2020-07-30',
    director: '陈望舒',
    writers: '白砚',
    cast: [
      { name: '宋子夜', role: '不良帅 苏昼', bio: '古装探案剧的熟面孔，表演干练。' },
      { name: '顾南枝', role: '仵作 柳青', bio: '灵气十足的青年女演员。' },
    ],
    intro: '盛世长安城，一桩连环谜案让不良帅陷入前所未有的困局。',
    synopsis: [
      '长安城内接连发生诡异命案，不良帅苏昼与仵作柳青合力追查，却发现案件与一桩旧日宫廷秘闻有关。',
      '繁华背后的暗流，远比想象中更加凶险。',
    ],
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20ancient%20Chinese%20capital%20city%20at%20night%20with%20lanterns%20and%20watchtowers%2C%20detective%20mood%2C%20deep%20navy%20blue%20and%20warm%20amber%20orange%20color%20grade%2C%20elegant%20minimal%20composition%2C%20high%20detail%2C%20professional%20film%20key%20art%2C%20no%20text&width=600&height=900&seq=tvposter-09&orientation=portrait',
    heroImage: '',
    updatedAt: '2026-03-15',
    featured: false,
    status: '已完结',
  },
  {
    id: 'wu-sheng-zheng-ci-2023',
    title: '无声证词',
    originalTitle: 'Wordless Evidence',
    score: 8.9,
    year: 2023,
    region: '国产剧',
    categories: ['guochan', 'xuanyi', 'fanzui'],
    tags: ['悬疑', '犯罪', '刑侦'],
    episodes: 28,
    duration: '43分钟',
    firstAir: '2023-05-19',
    director: '穆长风',
    writers: '沈砚',
    cast: [
      { name: '霍听寒', role: '法证 程野', bio: '理性冷静的角色塑造者。' },
      { name: '叶清辞', role: '刑警 林一', bio: '干脆利落的青年女演员。' },
    ],
    intro: '当证物开口说话，尘封多年的真相再无遁形之处。',
    synopsis: [
      '一名法证人员凭借对细节的极致敏感，从一具无名尸体上找到了陈年悬案的突破口。',
      '真相往往不在口供里，而藏在被忽略的证据中。',
    ],
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20forensic%20crime%20TV%20poster%20of%20evidence%20bags%20and%20gloved%20hands%20under%20cold%20light%2C%20tense%20mood%2C%20deep%20navy%20blue%20and%20warm%20amber%20orange%20color%20grade%2C%20elegant%20minimal%20composition%2C%20high%20detail%2C%20professional%20film%20key%20art%2C%20no%20text&width=600&height=900&seq=tvposter-10&orientation=portrait',
    heroImage: '',
    updatedAt: '2026-08-01',
    featured: false,
    status: '已完结',
  },
  {
    id: 'shen-xiang',
    title: '深巷',
    originalTitle: 'Deep Alley',
    score: 8.7,
    year: 2022,
    region: '国产剧',
    categories: ['guochan', 'fanzui', 'xiandai'],
    tags: ['犯罪', '都市', '现实'],
    episodes: 30,
    duration: '42分钟',
    firstAir: '2022-10-08',
    director: '岭南',
    writers: '何川',
    cast: [
      { name: '马ulbrick', role: '片警 老周', bio: '生活化表演的代表，极具亲和力。' },
      { name: '宋雨桐', role: '记者 苏禾', bio: '细腻真实的青年演员。' },
    ],
    intro: '一条老巷子里，藏着这座快速发展城市最真实的褶皱。',
    synopsis: [
      '老城改造的背景下，一条深巷成为多方利益交汇的漩涡，片警老周与记者苏禾试图守住这里的温度。',
      '在现实与理想之间，普通人也有自己的坚持。',
    ],
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20urban%20crime%20drama%20poster%20of%20a%20narrow%20old%20alley%20between%20tall%20buildings%20at%20dusk%2C%20realistic%20mood%2C%20deep%20navy%20blue%20and%20warm%20amber%20orange%20color%20grade%2C%20elegant%20minimal%20composition%2C%20high%20detail%2C%20professional%20film%20key%20art%2C%20no%20text&width=600&height=900&seq=tvposter-11&orientation=portrait',
    heroImage: '',
    updatedAt: '2026-02-11',
    featured: false,
    status: '已完结',
  },
  {
    id: 'cheng-shi-ye-mu',
    title: '城市夜幕',
    originalTitle: 'City Nightfall',
    score: 8.5,
    year: 2021,
    region: '国产剧',
    categories: ['guochan', 'fanzui', 'xiandai'],
    tags: ['犯罪', '都市', '悬疑'],
    episodes: 26,
    duration: '41分钟',
    firstAir: '2021-11-22',
    director: '周牧',
    writers: '林深',
    cast: [
      { name: '蓝时初', role: '刑警 高原', bio: '沉稳可靠的硬派男主。' },
      { name: '安然', role: '检察官 白露', bio: '干练气质的都市女性形象。' },
    ],
    intro: '灯火通明的都市背后，总有一群人彻夜守护着秩序。',
    synopsis: [
      '夜幕降临的城市里，刑警高原与检察官白露联手追查一条跨境犯罪链。',
      '霓虹之下，是善与恶从不间断的较量。',
    ],
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20crime%20thriller%20poster%20of%20a%20city%20skyline%20at%20night%20with%20rain%20and%20police%20lights%2C%20tense%20mood%2C%20deep%20navy%20blue%20and%20warm%20amber%20orange%20color%20grade%2C%20elegant%20minimal%20composition%2C%20high%20detail%2C%20professional%20film%20key%20art%2C%20no%20text&width=600&height=900&seq=tvposter-12&orientation=portrait',
    heroImage: '',
    updatedAt: '2026-01-28',
    featured: false,
    status: '已完结',
  },
  {
    id: 'ni-guang-er-xing',
    title: '逆光而行',
    originalTitle: 'Walking Against the Light',
    score: 8.4,
    year: 2024,
    region: '国产剧',
    categories: ['guochan', 'xiandai', 'aiqing'],
    tags: ['都市', '爱情', '成长'],
    episodes: 34,
    duration: '43分钟',
    firstAir: '2024-04-06',
    director: '温言',
    writers: '苏念',
    cast: [
      { name: '苏行舟', role: '创业者 江阔', bio: '阳光与深情兼具的都市男主。' },
      { name: '沈知微', role: '设计师 林知', bio: '气质清新的青年女演员。' },
    ],
    intro: '两个在人生低谷相遇的人，选择并肩逆光而行。',
    synopsis: [
      '创业失败的江阔与初入职场的设计师林知在一次意外中相识，各自带着伤痕的两人相互治愈。',
      '他们相信，只要朝着光走，路总会越来越亮。',
    ],
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20urban%20romance%20drama%20poster%20of%20a%20young%20couple%20on%20a%20rooftop%20at%20golden%20hour%2C%20warm%20hopeful%20mood%2C%20deep%20navy%20blue%20and%20warm%20amber%20orange%20color%20grade%2C%20elegant%20minimal%20composition%2C%20high%20detail%2C%20professional%20film%20key%20art%2C%20no%20text&width=600&height=900&seq=tvposter-13&orientation=portrait',
    heroImage: '',
    updatedAt: '2026-08-15',
    featured: false,
    status: '已完结',
  },
  {
    id: 'xing-gui-zhi-wai',
    title: '星轨之外',
    originalTitle: 'Beyond the Star Rails',
    score: 9.0,
    year: 2025,
    region: '国产剧',
    categories: ['guochan', 'kehuan'],
    tags: ['科幻', '硬核', '未来'],
    episodes: 22,
    duration: '48分钟',
    firstAir: '2025-03-01',
    director: '顾寒星',
    writers: '叶航 / 陆明',
    cast: [
      { name: '楚星河', role: '科学家 纪尘', bio: '理性与理想主义并存的男主角。' },
      { name: '凌昭', role: 'AI 工程师 罗夏', bio: '冷静专业的青年女演员。' },
    ],
    intro: '当人类第一次触碰星轨之外的边界，答案却指向自身。',
    synopsis: [
      '一支科研团队在深空观测中发现异常信号，随之而来的技术跃迁彻底改变了人类文明。',
      '在星辰与代码之间，他们必须回答一个古老的问题：我们是谁。',
    ],
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20hard%20sci-fi%20poster%20of%20a%20giant%20orbital%20ring%20above%20earth%20at%20night%2C%20epic%20mood%2C%20deep%20navy%20blue%20and%20warm%20amber%20orange%20color%20grade%2C%20elegant%20minimal%20composition%2C%20high%20detail%2C%20professional%20film%20key%20art%2C%20no%20text&width=600&height=900&seq=tvposter-14&orientation=portrait',
    heroImage: '',
    updatedAt: '2026-09-05',
    featured: false,
    status: '更新中',
  },
  {
    id: 'liang-zi-qiu-long',
    title: '量子囚笼',
    originalTitle: 'Quantum Cage',
    score: 8.8,
    year: 2023,
    region: '国产剧',
    categories: ['guochan', 'kehuan', 'xuanyi'],
    tags: ['科幻', '悬疑', '量子'],
    episodes: 20,
    duration: '47分钟',
    firstAir: '2023-08-12',
    director: '顾寒星',
    writers: '叶航',
    cast: [
      { name: '陆沉舟', role: '物理学家 谢临', bio: '高智感角色的代表人物。' },
      { name: '白清越', role: '研究员 沈澜', bio: '知性气质的实力女演员。' },
    ],
    intro: '一场量子实验的意外，让一个小镇陷入了循环的囚笼。',
    synopsis: [
      '量子物理学家谢临的实验出现意外，小镇被卷入一个不断重复的时间循环。',
      '要打破囚笼，他必须先弄明白：循环的钥匙，究竟握在谁手里。',
    ],
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20sci-fi%20mystery%20poster%20of%20a%20glass%20quantum%20chamber%20glowing%20in%20a%20dark%20lab%2C%20mysterious%20mood%2C%20deep%20navy%20blue%20and%20warm%20amber%20orange%20color%20grade%2C%20elegant%20minimal%20composition%2C%20high%20detail%2C%20professional%20film%20key%20art%2C%20no%20text&width=600&height=900&seq=tvposter-15&orientation=portrait',
    heroImage: '',
    updatedAt: '2026-05-27',
    featured: false,
    status: '已完结',
  },
  {
    id: 'jiu-cheng-gu-shi',
    title: '旧城故事',
    originalTitle: 'Tales of the Old Town',
    score: 8.9,
    year: 2020,
    region: '国产剧',
    categories: ['guochan', 'xiandai'],
    tags: ['年代', '现实', '群像'],
    episodes: 40,
    duration: '45分钟',
    firstAir: '2020-09-10',
    director: '赵久安',
    writers: '老舍迷',
    cast: [
      { name: '王砚秋', role: '厂长 周正', bio: '老戏骨，年代戏表演入木三分。' },
      { name: '李念慈', role: '教师 何秀', bio: '温润细腻的中生代女演员。' },
    ],
    intro: '一条老街的兴衰，几代人的悲欢，都被时间温柔收藏。',
    synopsis: [
      '从上世纪末到新时代，一条老街见证了几户人家的命运沉浮。',
      '没有惊天动地，只有细水长流里的人间烟火。',
    ],
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20period%20drama%20poster%20of%20an%20old%20Chinese%20town%20street%20in%20autumn%20with%20warm%20afternoon%20light%2C%20nostalgic%20mood%2C%20deep%20navy%20blue%20and%20warm%20amber%20orange%20color%20grade%2C%20elegant%20minimal%20composition%2C%20high%20detail%2C%20professional%20film%20key%20art%2C%20no%20text&width=600&height=900&seq=tvposter-16&orientation=portrait',
    heroImage: '',
    updatedAt: '2026-03-02',
    featured: false,
    status: '已完结',
  },
  {
    id: 'sui-yue-chang-he',
    title: '岁月长河',
    originalTitle: 'The Long River of Years',
    score: 9.1,
    year: 2019,
    region: '国产剧',
    categories: ['guochan', 'xiandai'],
    tags: ['年代', '家族', '现实'],
    episodes: 52,
    duration: '46分钟',
    firstAir: '2019-12-18',
    director: '赵久安',
    writers: '秦暮',
    cast: [
      { name: '沈望山', role: '大家长 沈父', bio: '气场十足的老一辈表演艺术家。' },
      { name: '周知微', role: '长女 沈昭', bio: '跨龄表演游刃有余。' },
    ],
    intro: '一个家族六十年的兴衰史，也是一部时代的缩影。',
    synopsis: [
      '从动荡到安宁，一个普通家族在六十年的岁月里几经离合。',
      '长河奔涌，唯有家风与亲情，始终不改。',
    ],
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20family%20saga%20poster%20of%20a%20multi-generational%20Chinese%20family%20in%20an%20old%20courtyard%2C%20warm%20nostalgic%20mood%2C%20deep%20navy%20blue%20and%20warm%20amber%20orange%20color%20grade%2C%20elegant%20minimal%20composition%2C%20high%20detail%2C%20professional%20film%20key%20art%2C%20no%20text&width=600&height=900&seq=tvposter-17&orientation=portrait',
    heroImage: '',
    updatedAt: '2026-01-15',
    featured: false,
    status: '已完结',
  },
  {
    id: 'wang-guan-yu-tie-jiang',
    title: '王冠与铁匠',
    originalTitle: 'The Crown and the Smith',
    score: 9.0,
    year: 2021,
    region: '欧美剧',
    categories: ['oumei', 'guzhuang'],
    tags: ['奇幻', '史诗', '权谋'],
    episodes: 24,
    duration: '56分钟',
    firstAir: '2021-04-25',
    director: 'Alistair Crane',
    writers: 'H. Marlowe',
    cast: [
      { name: 'Edmund Hale', role: '国王 奥里安', bio: '莎士比亚戏剧出身的英伦实力派。' },
      { name: 'Freya Lindqvist', role: '铁匠 布丽安娜', bio: '形象英气飒爽的北欧女演员。' },
    ],
    intro: '当王冠沉重到无法自持，唯有铁与火能重塑秩序。',
    synopsis: [
      '在分裂的大陆上，年轻的国王与出身平民的铁匠被迫结盟，共同对抗觊觎王座的外敌。',
      '权力与忠诚的博弈中，他们需要重新理解什么是真正的王。',
    ],
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20fantasy%20epic%20poster%20of%20a%20king%20and%20a%20blacksmith%20before%20a%20forge%20in%20a%20great%20hall%2C%20epic%20mood%2C%20deep%20navy%20blue%20and%20warm%20amber%20orange%20color%20grade%2C%20elegant%20minimal%20composition%2C%20high%20detail%2C%20professional%20film%20key%20art%2C%20no%20text&width=600&height=900&seq=tvposter-18&orientation=portrait',
    heroImage: '',
    updatedAt: '2026-04-08',
    featured: false,
    status: '已完结',
  },
  {
    id: 'bing-yuan-lie-che',
    title: '冰原列车',
    originalTitle: 'The Icefield Train',
    score: 8.9,
    year: 2022,
    region: '欧美剧',
    categories: ['oumei', 'xuanyi'],
    tags: ['悬疑', '惊悚', '封闭空间'],
    episodes: 10,
    duration: '54分钟',
    firstAir: '2022-02-17',
    director: 'Sofia Bergman',
    writers: 'N. Dahl',
    cast: [
      { name: 'Lars Nyberg', role: '乘警 埃里克', bio: '北欧悬疑剧的常客，气质冷峻。' },
      { name: 'Elsa Vinter', role: '医生 玛丽', bio: '细腻沉稳的表演风格。' },
    ],
    intro: '一列穿越冰原的列车，在暴风雪中载着一位凶手疾驰。',
    synopsis: [
      '一列横穿冰原的夜行列车遭遇暴风雪被迫停驶，乘客中有人死了，凶手就在车上。',
      '在封闭的空间里，每个人都可能是猎物，也可能是猎手。',
    ],
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20thriller%20poster%20of%20a%20lone%20train%20crossing%20a%20snowy%20wasteland%20at%20night%2C%20cold%20tense%20mood%2C%20deep%20navy%20blue%20and%20warm%20amber%20orange%20color%20grade%2C%20elegant%20minimal%20composition%2C%20high%20detail%2C%20professional%20film%20key%20art%2C%20no%20text&width=600&height=900&seq=tvposter-19&orientation=portrait',
    heroImage: '',
    updatedAt: '2026-06-20',
    featured: false,
    status: '已完结',
  },
  {
    id: 'jing-mo-zheng-ren',
    title: '静默证人',
    originalTitle: 'The Quiet Witness',
    score: 8.7,
    year: 2020,
    region: '欧美剧',
    categories: ['oumei', 'fanzui', 'xuanyi'],
    tags: ['犯罪', '悬疑', '律政'],
    episodes: 12,
    duration: '50分钟',
    firstAir: '2020-05-14',
    director: 'Gregory Poe',
    writers: 'D. Whitfield',
    cast: [
      { name: 'Nathan Cross', role: '警探 韦恩', bio: '气质沧桑的硬派男演员。' },
      { name: 'Ivy Sloane', role: '助理检察官 诺拉', bio: '干练锋利的法庭戏好手。' },
    ],
    intro: '唯一的目击者不愿开口，而真相正在沉默中腐烂。',
    synopsis: [
      '一桩街角枪案唯一的目击者拒绝作证，警探与检察官必须在沉默中寻找突破口。',
      '当恐惧成为帮凶，正义需要更多勇气。',
    ],
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20crime%20drama%20poster%20of%20a%20witness%20behind%20blinds%20in%20a%20dark%20apartment%2C%20tense%20mood%2C%20deep%20navy%20blue%20and%20warm%20amber%20orange%20color%20grade%2C%20elegant%20minimal%20composition%2C%20high%20detail%2C%20professional%20film%20key%20art%2C%20no%20text&width=600&height=900&seq=tvposter-20&orientation=portrait',
    heroImage: '',
    updatedAt: '2026-02-25',
    featured: false,
    status: '已完结',
  },
  {
    id: 'luo-ji-shan-mai-de-dong-tian',
    title: '落基山脉的冬天',
    originalTitle: 'Winter in the Rockies',
    score: 8.6,
    year: 2019,
    region: '欧美剧',
    categories: ['oumei', 'xiandai'],
    tags: ['家庭', '剧情', '治愈'],
    episodes: 16,
    duration: '48分钟',
    firstAir: '2019-10-06',
    director: 'Amelia Frost',
    writers: 'K. Larsen',
    cast: [
      { name: 'Daniel Reyes', role: '护林员 杰克', bio: '温暖可靠的家庭剧代表演员。' },
      { name: 'Hannah Bell', role: '医生 凯特', bio: '细腻动人的表演风格。' },
    ],
    intro: '在一座雪山小镇，一群陌生人因为一个冬天成为家人。',
    synopsis: [
      '暴雪封路的小镇里，护林员与医生意外收留了几位被困的旅人。',
      '一个漫长的冬天，让彼此陌生的他们慢慢成为彼此的依靠。',
    ],
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20family%20drama%20poster%20of%20a%20cozy%20wooden%20cabin%20in%20snowy%20mountains%20at%20dusk%20with%20warm%20windows%2C%20healing%20mood%2C%20deep%20navy%20blue%20and%20warm%20amber%20orange%20color%20grade%2C%20elegant%20minimal%20composition%2C%20high%20detail%2C%20professional%20film%20key%20art%2C%20no%20text&width=600&height=900&seq=tvposter-21&orientation=portrait',
    heroImage: '',
    updatedAt: '2026-01-09',
    featured: false,
    status: '已完结',
  },
  {
    id: 'mei-gui-zhuang-yuan',
    title: '玫瑰庄园',
    originalTitle: 'Rose Manor',
    score: 8.5,
    year: 2021,
    region: '欧美剧',
    categories: ['oumei', 'aiqing', 'guzhuang'],
    tags: ['爱情', '年代', '古典'],
    episodes: 14,
    duration: '52分钟',
    firstAir: '2021-07-11',
    director: 'Charlotte Wren',
    writers: 'E. Hastings',
    cast: [
      { name: 'Henry Ashford', role: '庄园主 爱德华', bio: '英伦古典气质出众的男主角。' },
      { name: 'Rose Pemberton', role: '继承人 克拉拉', bio: '优雅从容的古典年代剧女演员。' },
    ],
    intro: '一座玫瑰庄园里，爱情与遗产的争夺同样芬芳而锋利。',
    synopsis: [
      '百年庄园的继承人克拉拉在父亲离世后，不得不面对来自各方的觊觎。',
      '在玫瑰盛开的院子里，她既要守护家业，也要厘清自己的真心。',
    ],
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20period%20romance%20poster%20of%20an%20elegant%20manor%20house%20with%20a%20rose%20garden%20at%20sunset%2C%20romantic%20classical%20mood%2C%20deep%20navy%20blue%20and%20warm%20amber%20orange%20color%20grade%2C%20elegant%20minimal%20composition%2C%20high%20detail%2C%20professional%20film%20key%20art%2C%20no%20text&width=600&height=900&seq=tvposter-22&orientation=portrait',
    heroImage: '',
    updatedAt: '2026-03-19',
    featured: false,
    status: '已完结',
  },
  {
    id: 'di-qi-dang-an-shi',
    title: '第七档案室',
    originalTitle: 'Archive Room Seven',
    score: 9.1,
    year: 2024,
    region: '欧美剧',
    categories: ['oumei', 'xuanyi', 'kehuan'],
    tags: ['悬疑', '科幻', '档案'],
    episodes: 9,
    duration: '55分钟',
    firstAir: '2024-01-20',
    director: 'Julian Ashcroft',
    writers: 'M. Keller',
    cast: [
      { name: 'Adrian Fox', role: '档案员 西蒙', bio: '高智商气质角色的固定人选。' },
      { name: 'Nadia Petrov', role: '特工 薇拉', bio: '冷艳干练的动作戏女演员。' },
    ],
    intro: '一间存放着“不该存在”的档案的密室，正等待被打开。',
    synopsis: [
      '新上任的档案员西蒙被分配到一个几乎没有同事的部门：第七档案室。',
      '这里保存的不是历史，而是那些从未被允许发生的事件。',
    ],
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20sci-fi%20mystery%20poster%20of%20an%20endless%20archive%20hall%20lined%20with%20glowing%20files%2C%20mysterious%20mood%2C%20deep%20navy%20blue%20and%20warm%20amber%20orange%20color%20grade%2C%20elegant%20minimal%20composition%2C%20high%20detail%2C%20professional%20film%20key%20art%2C%20no%20text&width=600&height=900&seq=tvposter-23&orientation=portrait',
    heroImage: '',
    updatedAt: '2026-09-24',
    featured: false,
    status: '更新中',
  },
  {
    id: 'jing-du-wan-feng',
    title: '京都晚风',
    originalTitle: 'Evening Breeze in Kyoto',
    score: 9.0,
    year: 2023,
    region: '日韩剧',
    categories: ['rihan', 'aiqing', 'xiandai'],
    tags: ['爱情', '治愈', '都市'],
    episodes: 12,
    duration: '45分钟',
    firstAir: '2023-04-03',
    director: '佐藤 悠人',
    writers: '小林 由纪',
    cast: [
      { name: '高桥 凉太', role: '陶艺师 凉介', bio: '气质温润的日剧实力男演员。' },
      { name: '石川 咲', role: '编辑 美月', bio: '清新自然的青年女演员。' },
    ],
    intro: '两条平行的人生，在京都的晚风里慢慢靠近。',
    synopsis: [
      '在京都老街经营陶艺工坊的凉介，与从东京来到这里的编辑美月相遇。',
      '慢下来的城市与慢下来的心，让两个疲惫的人重新学会喜欢。',
    ],
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20japanese%20romance%20drama%20poster%20of%20a%20quiet%20Kyoto%20street%20with%20wind%20and%20lanterns%20at%20dusk%2C%20gentle%20healing%20mood%2C%20deep%20navy%20blue%20and%20warm%20amber%20orange%20color%20grade%2C%20elegant%20minimal%20composition%2C%20high%20detail%2C%20professional%20film%20key%20art%2C%20no%20text&width=600&height=900&seq=tvposter-24&orientation=portrait',
    heroImage: '',
    updatedAt: '2026-07-02',
    featured: false,
    status: '已完结',
  },
  {
    id: 'shou-er-ye-xing',
    title: '首尔夜行',
    originalTitle: 'Seoul Night Walk',
    score: 8.9,
    year: 2022,
    region: '日韩剧',
    categories: ['rihan', 'fanzui', 'xuanyi'],
    tags: ['犯罪', '悬疑', '都市'],
    episodes: 16,
    duration: '50分钟',
    firstAir: '2022-09-15',
    director: '김 明俊',
    writers: '박 서연',
    cast: [
      { name: '李 在勋', role: '刑警 泰洙', bio: '韩国犯罪剧的实力派男主。' },
      { name: '韩 素熙', role: '记者 智恩', bio: '气场凌厉的青年女演员。' },
    ],
    intro: '首尔的夜路很长，而真相总在最黑的转角。',
    synopsis: [
      '刑警泰洙在调查一系列夜间案件时，发现线索都指向一家早已倒闭的夜店。',
      '在霓虹与黑暗之间，他与记者智恩一同逼近真相。',
    ],
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20korean%20crime%20thriller%20poster%20of%20a%20neon%20lit%20Seoul%20night%20street%20with%20rain%2C%20tense%20mood%2C%20deep%20navy%20blue%20and%20warm%20amber%20orange%20color%20grade%2C%20elegant%20minimal%20composition%2C%20high%20detail%2C%20professional%20film%20key%20art%2C%20no%20text&width=600&height=900&seq=tvposter-25&orientation=portrait',
    heroImage: '',
    updatedAt: '2026-05-14',
    featured: false,
    status: '已完结',
  },
  {
    id: 'chun-zhi-xue',
    title: '春之雪',
    originalTitle: 'Snow of Spring',
    score: 8.8,
    year: 2021,
    region: '日韩剧',
    categories: ['rihan', 'aiqing'],
    tags: ['爱情', '纯爱', '治愈'],
    episodes: 11,
    duration: '46分钟',
    firstAir: '2021-03-12',
    director: '山田 和树',
    writers: '中村 明',
    cast: [
      { name: '木村 翔', role: '摄影师 冬吾', bio: '气质清冷的纯爱剧男主。' },
      { name: '内田 结衣', role: '护士 雪乃', bio: '温柔细腻的青年女演员。' },
    ],
    intro: '在春天落下的那场雪里，一段遗憾的爱情被重新拾起。',
    synopsis: [
      '摄影师冬吾与护士雪乃在一场春天的初雪中重逢，唤醒了一段被搁置多年的往事。',
      '有些爱，需要很长时间才能说出口。',
    ],
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20pure%20love%20japanese%20drama%20poster%20of%20a%20couple%20under%20cherry%20blossoms%20with%20falling%20snow%2C%20gentle%20melancholic%20mood%2C%20deep%20navy%20blue%20and%20warm%20amber%20orange%20color%20grade%2C%20elegant%20minimal%20composition%2C%20high%20detail%2C%20professional%20film%20key%20art%2C%20no%20text&width=600&height=900&seq=tvposter-26&orientation=portrait',
    heroImage: '',
    updatedAt: '2026-04-30',
    featured: false,
    status: '已完结',
  },
  {
    id: 'dong-jing-wu-yu-xin-zhang',
    title: '东京物语新章',
    originalTitle: 'Tokyo Story: A New Chapter',
    score: 9.1,
    year: 2020,
    region: '日韩剧',
    categories: ['rihan', 'xiandai'],
    tags: ['家庭', '剧情', '现实'],
    episodes: 10,
    duration: '47分钟',
    firstAir: '2020-11-08',
    director: '大野 诚',
    writers: '清水 玲',
    cast: [
      { name: '中岛 健', role: '长子 浩司', bio: '沉稳内敛的家庭剧男演员。' },
      { name: '松本 由美', role: '长女 千夏', bio: '表演真挚动人的实力派。' },
    ],
    intro: '一个普通家庭的聚散离合，是每个都市人的镜子。',
    synopsis: [
      '年迈的父母从乡下到东京看望子女，却发现彼此早已生活在不同的世界里。',
      '关于亲情、距离与和解，这部剧给出了温柔的答案。',
    ],
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20japanese%20family%20drama%20poster%20of%20an%20elderly%20couple%20on%20a%20train%20platform%20in%20Tokyo%2C%20quiet%20melancholic%20mood%2C%20deep%20navy%20blue%20and%20warm%20amber%20orange%20color%20grade%2C%20elegant%20minimal%20composition%2C%20high%20detail%2C%20professional%20film%20key%20art%2C%20no%20text&width=600&height=900&seq=tvposter-27&orientation=portrait',
    heroImage: '',
    updatedAt: '2026-02-06',
    featured: false,
    status: '已完结',
  },
  {
    id: 'zhou-shu-hui-xiang',
    title: '咒术回响',
    originalTitle: 'Echoes of the Arcane',
    score: 8.7,
    year: 2024,
    region: '日韩剧',
    categories: ['rihan', 'kehuan'],
    tags: ['奇幻', '动作', '超自然'],
    episodes: 20,
    duration: '44分钟',
    firstAir: '2024-07-05',
    director: '佐藤 悠人',
    writers: '藤田 涼',
    cast: [
      { name: '藤原 拓真', role: '术士 隼人', bio: '动作与情绪戏兼备的年轻演员。' },
      { name: '宫崎 凛', role: '灵媒 纱罗', bio: '气质神秘的新生代女演员。' },
    ],
    intro: '当古老咒术在现代都市回响，一群年轻人肩负起守护的使命。',
    synopsis: [
      '在看似平静的现代都市下，古老的咒术与超自然力量从未消失。',
      '一群年轻的术士在暗处守护着普通人的日常，也守护着彼此。',
    ],
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20supernatural%20action%20poster%20of%20a%20young%20sorcerer%20with%20glowing%20sigils%20in%20a%20modern%20city%20at%20night%2C%20mystical%20mood%2C%20deep%20navy%20blue%20and%20warm%20amber%20orange%20color%20grade%2C%20elegant%20minimal%20composition%2C%20high%20detail%2C%20professional%20film%20key%20art%2C%20no%20text&width=600&height=900&seq=tvposter-28&orientation=portrait',
    heroImage: '',
    updatedAt: '2026-08-28',
    featured: false,
    status: '更新中',
  },
  {
    id: 'mi-wu-zhi-dao',
    title: '迷雾之岛',
    originalTitle: 'Island of Mist',
    score: 8.8,
    year: 2018,
    region: '欧美剧',
    categories: ['oumei', 'xuanyi'],
    tags: ['悬疑', '孤岛', '惊悚'],
    episodes: 8,
    duration: '53分钟',
    firstAir: '2018-10-19',
    director: 'Gregory Poe',
    writers: 'N. Dahl',
    cast: [
      { name: 'Patrick Nolan', role: '调查员 布伦南', bio: '冷峻气质的悬疑剧常客。' },
      { name: 'Greta Lindholm', role: '岛民 艾达', bio: '表演充满张力与神秘感。' },
    ],
    intro: '一座不在地图上的孤岛，收留着所有被遗忘的秘密。',
    synopsis: [
      '一名调查员为寻找失踪的同事，登上一座常年被浓雾包围的孤岛。',
      '岛上的居民对外人充满警惕，而真相就藏在他们的沉默里。',
    ],
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20mystery%20poster%20of%20a%20lone%20island%20shrouded%20in%20mist%20with%20a%20small%20boat%20approaching%2C%20eerie%20mood%2C%20deep%20navy%20blue%20and%20warm%20amber%20orange%20color%20grade%2C%20elegant%20minimal%20composition%2C%20high%20detail%2C%20professional%20film%20key%20art%2C%20no%20text&width=600&height=900&seq=tvposter-29&orientation=portrait',
    heroImage: '',
    updatedAt: '2026-01-03',
    featured: false,
    status: '已完结',
  },
  {
    id: 'huan-meng-qian-nian',
    title: '幻梦千年',
    originalTitle: 'A Thousand Years of Dream',
    score: 8.6,
    year: 2024,
    region: '国产剧',
    categories: ['guochan', 'guzhuang', 'kehuan'],
    tags: ['奇幻', '古装', '史诗'],
    episodes: 36,
    duration: '45分钟',
    firstAir: '2024-11-01',
    director: '裴云舟',
    writers: '陆沉 / 苏念',
    cast: [
      { name: '云归舟', role: '守护者 玄弋', bio: '古装奇幻题材的男主角代表。' },
      { name: '苏月见', role: '祭司 浮生', bio: '仙气十足的古装女演员。' },
    ],
    intro: '一场跨越千年的梦境，连接起两个时代的命运。',
    synopsis: [
      '现代考古学者意外唤醒了一段沉睡千年的记忆，与古代守护者的命运产生了共鸣。',
      '千年一梦，究竟是轮回，还是未竟的执念。',
    ],
    poster: 'https://readdy.ai/api/search-image?query=cinematic%20fantasy%20historical%20poster%20of%20a%20robed%20guardian%20before%20an%20ancient%20floating%20temple%20in%20clouds%2C%20epic%20dreamlike%20mood%2C%20deep%20navy%20blue%20and%20warm%20amber%20orange%20color%20grade%2C%20elegant%20minimal%20composition%2C%20high%20detail%2C%20professional%20film%20key%20art%2C%20no%20text&width=600&height=900&seq=tvposter-30&orientation=portrait',
    heroImage: '',
    updatedAt: '2026-09-18',
    featured: false,
    status: '已完结',
  },
];

export const featuredShows: TvShow[] = [
  shows[0],
  shows[1],
  shows[2],
  shows[3],
  shows[4],
];